import isValidUrl from 'app/lib/isValidUrl'
import { IconArrowUp } from 'components/icons'
import Link from 'components/shared/link'
import WidgetWrapper from 'components/WidgetWrapper'
import Image from 'next/image'
import NextLink from 'next/link'
import { FaDiscord, FaTwitch, FaXTwitter, FaYoutube } from 'react-icons/fa6'
import { MdFacebook } from 'react-icons/md'
import { RiInstagramFill } from 'react-icons/ri'

interface FooterTexts {
    privacyPolicy: string
    termsOfService: string
    cookiesPolicy: string
    home: string
    aboutUs: string
    contactUs: string
    cuttingEdgeESportsSolutions: string
    legal: string
    info: string
}

interface FooterProps {
    texts: FooterTexts
    removeController?: boolean
    config: IDomainConfig
    isHostDomain: boolean
}

const Footer: React.FC<FooterProps> = ({ texts, config, isHostDomain, removeController }) => {
    const legalLinks = [
        { href: '/info/privacy-policy', text: texts.privacyPolicy },
        { href: '/info/tos', text: texts.termsOfService },
        { href: '/info/cookies-policy', text: texts.cookiesPolicy }
    ]

    const infoLinks = [
        { href: '/home', text: texts.home },
        { href: '/info/about-us', text: texts.aboutUs },
        { href: '/info/contact-us', text: texts.contactUs }
    ]

    return (
        <WidgetWrapper>
            <footer className='flex flex-col w-full lg:h-[420px] h-fit mt-16 px-3 md:px-0 relative'>
                <div className='flex flex-col gap-y-4 h-[80%] relative'>
                    {!removeController && (
                        <div className='h-full w-[380px] lg:w-[600px] lg:h-full absolute right-10'>
                            <Image
                                src='/images/layouts/light_game_pad.png'
                                alt='light game pad'
                                fill
                                className='object-contain lg:scale-150'
                            />
                        </div>
                    )}
                    <div className='flex flex-col lg:flex-row gap-10 pb-10'>
                        <div className='flex flex-col gap-y-4'>
                            <NextLink href={process.env.HOST_DOMAIN || '/'}>
                                <div className={`relative ${isHostDomain ? 'h-8 w-32 md:h-12 md:w-36' : 'h-20 w-20'}`}>
                                    <Image
                                        src={`${isHostDomain || !isValidUrl(config?.organisation_logo || '') ? '/images/logos/disporty_logo_and_text.png' : config?.organisation_logo} `}
                                        fill
                                        className='object-contain'
                                        alt='Disporty logo'
                                    />
                                </div>
                            </NextLink>
                            <p className='font-light'>{texts.cuttingEdgeESportsSolutions}</p>
                            <div className='flex gap-4 items-center'>
                                {config?.twitter && (
                                    <NextLink href={config?.twitter} target='_blank'>
                                        <FaXTwitter className='!size-5' />
                                    </NextLink>
                                )}
                                {config?.facebook && (
                                    <NextLink href={config?.facebook} target='_blank'>
                                        <MdFacebook className='!size-7' />
                                    </NextLink>
                                )}
                                {config?.instagram && (
                                    <NextLink href={config?.instagram} target='_blank'>
                                        <RiInstagramFill className='!size-7' />
                                    </NextLink>
                                )}
                                {config?.discord && (
                                    <NextLink href={config?.discord} target='_blank'>
                                        <FaDiscord className='!size-7' />
                                    </NextLink>
                                )}
                                {config?.youtube && (
                                    <NextLink href={config?.youtube} target='_blank'>
                                        <FaYoutube className='!size-7' />
                                    </NextLink>
                                )}
                                {config?.twitch && (
                                    <NextLink href={config?.twitch} target='_blank'>
                                        <FaTwitch className='!size-6' />
                                    </NextLink>
                                )}
                            </div>
                        </div>
                        <div className='gap-y-3 flex flex-col font-light relative z-10'>
                            <p className='font-bold'>{texts.legal}</p>
                            {legalLinks.map(({ href, text }) => (
                                <Link key={href} href={href} className='cursor-pointer hover:underline'>
                                    {text}
                                </Link>
                            ))}
                        </div>
                        <div className='gap-y-3 flex flex-col font-light relative z-10'>
                            <p className='font-bold'>{texts.info}</p>
                            {infoLinks.map(({ href, text }) => (
                                <Link key={href} href={href} className='cursor-pointer hover:underline'>
                                    {text}
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
                <div className='flex justify-between items-center'>
                    <p className='py-4'>
                        Copyright © {config?.site_name || 'DISPORTY'} {new Date().getFullYear()}{' '}
                        {!isHostDomain && '- Powered by DISPORTY'}
                    </p>
                    <Link
                        href='#'
                        className='text-sm flex items-center py-1 px-4 rounded-md glassmorphism absolute right-4 bottom-16 md:bottom-8 '
                    >
                        <IconArrowUp />
                    </Link>
                </div>
            </footer>
        </WidgetWrapper>
    )
}

export default Footer
